import React, { FunctionComponent } from 'react';
import { List } from '@mui/material';
import ResourceItem from './ResourceItem';
import { IResourcesGroup } from '../../../interfaces/resourcesGroup.interface';
import useStyles from './ResourcesGroup.styles';

type Props =  {
  resourcesGroup: IResourcesGroup;
};

const ResourcesGroup: FunctionComponent<Props> = ({ resourcesGroup }) => {
  const classes = useStyles();
  const { header, resources } = resourcesGroup;
  return (
    <>
      <div className={classes.groupHeader}>{header}</div>
      <List>
        {
          resources.map((resource, index) =>
            <ResourceItem key={`${resource.label}_${index}`} resource={resource} />
          )
        }
      </List>
    </>
  );
};

export default ResourcesGroup;